import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { DmFormComponent } from '@components/form/form.component';
import { DmToolbarComponent } from '@components/form/toolbar/toolbar.component';
import { ModalWrapperComponent } from '@components/modal-wrapper/modal-wrapper.component';

@NgModule({
    declarations: [ModalWrapperComponent, DmFormComponent, DmToolbarComponent],
    imports: [ModalModule, ReactiveFormsModule, CommonModule, TranslateModule],
    exports: [ModalWrapperComponent, DmFormComponent, DmToolbarComponent],
})
export class ModalWrapperModule {}
